import { render } from "./PrepareTips.vue?vue&type=template&id=4b2f5906&scoped=true"
import script from "./PrepareTips.vue?vue&type=script&lang=js"
export * from "./PrepareTips.vue?vue&type=script&lang=js"

import "./PrepareTips.vue?vue&type=style&index=0&id=4b2f5906&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f5906"]])

export default __exports__